<template>
<transition
  @before-enter="beforeEnter"
  @enter="enter"
  @after-enter="afterEnter"
  @before-leave="beforeLeave"
  @leave="leave"
  @after-leave="afterLeave"
>
<div v-show="isShow" class="p-top"></div>
</transition>
</template>

<script>
import { gsap } from 'gsap/gsap-core';
import { Observer } from 'gsap/Observer';

export default {
  data() {
    return {
      isPageTransition: false,
      dObserver: null,
      isLink: false,
      routeFrom: null,
      afterRoute: null,
    }
  },
  computed: {
    isShow() {
      return this.$store.getters.isShowTop && this.$store.getters.isFirstLoaded;
    },
    isStart() {
      return this.$store.getters.isStartTop;
    },
  },
  watch: {
    isShow (isNew, isOld) {
      if (isNew) {
        this.show();
      }
    },
    isStart (isNew, isOld) {
      if (isNew) {
        this.start();
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.routeFrom = from;
      vm.$store.commit('setShowTop', true);
    });
  },
  // beforeRouteUpdate(to, from, next) {
  //   this.routeFrom = from;
  //   next();
  // },
  beforeRouteLeave(to, from, next) {
    if (this.afterRoute === null) {
      this.reset();
    }
    this.afterRoute = null;
    next();
  },

  mounted() {
  },
  methods: {
    show() {
      if (this.routeFrom.name === undefined) {
        // 初回アクセス
        this.$store.commit('isBgInit', true);
      } else {
        // POLOから
        this.$store.commit('isBgTop2', true);
        this.$store.commit('setStartTop', true);
      }
    },
    start() {
      this.setting();

      if (this.routeFrom.name === undefined) {
        // 初回アクセス
        this.$store.commit('isBgTop1', true);
      }
    },
    setting() {
      this.dObserver = Observer.create({
        target: this.$el,
        type: 'wheel,touch,pointer',
        // dragMinimum: 10,
        // tolerance: 10,
        // preventDefault: true,
        // axis: 'x',
        lockAxis: true,
        // wheelSpeed: -1,
        onWheel: this.wheel,
        onPress: this.dragPress,
        onDrag: this.drag,
        onDragEnd: this.dragEnd,
      });
    },
    reset() {
      this.isPageTransition = false;

      // ドラッグ、ホイール、タッチイベント
      if (this.dObserver) {
        this.dObserver.kill();
        this.dObserver = null;
      }

      // 背景のフラグ
      this.$store.commit('isBgInit', false);
      this.$store.commit('isBgTop1', false);
      this.$store.commit('isBgTop2', false);

      this.$store.commit('setShowVideo', false);
      this.$store.commit('setStartTop', false);
      this.$store.commit('setShowTop', false);
    },

    gotoPolo() {
      this.afterRoute = {name: 'polo', params: {id: 'orange'}};

      this.isPageTransition = true;
      this.$store.commit('setShowVideo', false);
      this.$store.commit('setStartTop', false);
      this.$store.commit('setShowTop', false);
    },

    wheel() {
      if (this.isPageTransition) return;
      if (!this.isShow) return;

      const d = this.dObserver;
      if (!d) return;
      if (d.deltaY < 20) return;
      this.gotoPolo();
    },
    dragPress() {
    },
    drag(self) {
      const d = this.dObserver;
      if (d.axis !== 'y') return;
      if (d.y - d.startY < -20) {
        this.isLink = true;
      } else {
        this.isLink = false;
      }
    },
    dragEnd() {
      if (this.isPageTransition) return;
      if (!this.isShow) return;
      if (this.isLink) {
        this.gotoPolo();
      }
    },

    beforeEnter() {},
    enter(el, done) {
      gsap.delayedCall(1, () => {
        done();
      });
    },
    afterEnter() {
    },

    beforeLeave() {},
    leave(el, done) {
      gsap.delayedCall(1.5, () => {
        done();
      });
    },
    afterLeave() {
      if (this.afterRoute) {
        this.reset();
        this.$router.push(this.afterRoute);
      }
    },
  },
}
</script>